import { I18n } from "i18n-js";
import translations from "./exported-locales/translations.json";

// Fetch user locale from html#lang.
// This value is being set on `app/views/layouts/application.html.erb` and
// is inferred from `ACCEPT-LANGUAGE` header.

const i18n = new I18n();
i18n.store(translations);
i18n.defaultLocale = ENV.default_locale || "en";
i18n.enableFallback = true;
i18n.locale = ENV.locale;

const slavicPluralization = function (_i18n, count) {
  if (count == 1) {
    return ["one"];
  } else if (count > 1 && count < 5) {
    return ["few"];
  } else {
    return ["other"];
  }
};

i18n.pluralization.register("sk", slavicPluralization);
i18n.pluralization.register("cs", slavicPluralization);
i18n.pluralization.register("pl", slavicPluralization);

export default i18n;
